import { StripeWrap } from '@/core/stripe.middleware';
import React, { useEffect } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { Box, Button, Container } from '@material-ui/core';

function AddCard() {
  const stripe = useStripe();
  const elements = useElements();

  const [values, setValues] = React.useState({});

  const handleAddCard = async () => {
    const card = elements.getElement(CardElement);
    const result = await stripe.createPaymentMethod({
      type: 'card',
      card,
      billing_details: {
        name: `${values?.firstName} ${values?.lastName}`,
        address: {
          country: values?.country,
        },
        email: values?.email,
      },
    });

    if (!window.ReactNativeWebView) {
      console.error('ReactNativeWebView not found');
      return;
    }

    window.ReactNativeWebView.postMessage(JSON.stringify(result));
  };

  useEffect(() => {
    const _v = JSON.parse(
      window.sessionStorage.getItem('mobile-values') ?? '{}'
    );

    setValues(_v);
  }, []);

  return (
    <Container>
      <Box>
        <CardElement />

        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={handleAddCard}
        >
          Save Card
        </Button>
      </Box>
    </Container>
  );
}

export default function AddCardContainer() {
  return (
    <StripeWrap>
      <AddCard />
    </StripeWrap>
  );
}
